import { Tooltip } from '@design/components/tooltip/Tooltip';
import {
  InsightIconsRoot,
  InsightIconsRootProps,
} from '@terminal/components/insight-icons-root/InsightIconsRoot';
import { InsightDetails } from '@terminal/components/insights-group/insight-card/insights-details/InsightDetails';
import React, { memo, ReactElement } from 'react';

import styles from './InsightsTooltip.module.scss';

interface InsightsTooltipProps extends InsightIconsRootProps {
  children: ReactElement<Record<string, unknown>>;
  horizon: string;
  median: number;
  name: string;
  stars: number;
  entityTag?: string;
  episodeLabel: string;
}

export const InsightsTooltipComponent = ({
  horizon,
  median,
  name,
  stars,
  children,
  entityTag,
  episodeLabel,
  ...rest
}: InsightsTooltipProps) => {
  const tooltipContent = () => {
    return (
      <div className={styles.bubble}>
        <InsightIconsRoot {...rest} />
        <InsightDetails
          isTooltip
          median={median}
          horizon={horizon}
          name={name}
          stars={stars}
          direction={rest.direction}
          isNewInsight={rest.isStarred}
          entityTag={entityTag}
          episodeLabel={episodeLabel}
        />
      </div>
    );
  };

  return (
    <Tooltip
      className={styles.tooltip}
      placement="top-start"
      label={tooltipContent()}
      inPortal
    >
      {children}
    </Tooltip>
  );
};

export const InsightsTooltip = memo(InsightsTooltipComponent);
